export const RESOURCE_STATE = {
  AVAILABLE: 'AVAILABLE',
  INACTIVE: 'INACTIVE',
  BUSY: 'BUSY',
  DEPLOYING: 'DEPLOYING',
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED',
  SUSPENDED: 'SUSPENDED',
  FAILED_SUSPENDED: 'FAILED_SUSPENDED',
  UPDATING: 'UPDATING',
  FAILED_UPDATING: 'FAILED_UPDATING',
  DESTROYING: 'DESTROYING',
  FAILED_DESTROYING: 'FAILED_DESTROYING',
  TERMINATED: 'TERMINATED',
};
